<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

@if (showField) {
  <span class="lf-field-title-container">
    <span class="lf-field-title" title="{{ lfFieldInfo.displayName }}">{{ lfFieldInfo.displayName }}</span>
    @if (lfFieldInfo.isRequired) {
      <span class="lf-field-is-required">*</span>
    }
    @if (isLoading) {
      <lfint-loader-component></lfint-loader-component>
    }
  </span>
  <form class="lf-field-form" [formGroup]="multiValueFieldParentForm">
    @for (
      lfFieldValue of lfFieldValues;
      track trackByIndex(currentIndex, lfFieldValue);
      let currentIndex = $index;
      let isLast = $last
    ) {
      <span class="single-field-container">
        <lfint-field-base-component
          [parentForm]="multiValueFieldParentForm"
          [lfFieldFormControl]="getSingleField(currentIndex)"
          [lfFieldInfo]="getLfFieldInfo(currentIndex)"
          [lfFieldValue]="lfFieldValue"
          [dynamicFieldValueOptions]="getOptions()"
          (fieldValueChange)="onChange($event, currentIndex)"
        >
        </lfint-field-base-component>
        @if (!isLast && lfFieldValues.length > 1) {
          <button class="lf-multivalue-remove-button" (click)="removeField(currentIndex)">
            <span class="material-icons" id="lf-multivalue-remove-icon"> close </span>
          </button>
        }
        @if (isLast && lfFieldValues.length > 1) {
          <span class="lf-multivalue-remove-span"></span>
        }
      </span>
    }
  </form>
}
